{
  "a11y": {
    "home": "bPanel, home"
  },
  "footer": {
    "rights": "All rights reserved.",
    "terms": "Terms",
    "privacy": "Privacy",
    "contact": "Contact us"
  },
  "fields": {
    "name": "Name",
    "workEmail": "Work email",
    "email": "Email",
    "password": "Password",
    "passwordHint": "At least 10 characters. Mixing letters, numbers and symbols is best.",
    "company": "Company name",
    "country": "Country",
    "newPassword": "New password",
    "confirmPassword": "Confirm password"
  },
  "signUp": {
    "docTitle": "Create an account",
    "title": "Start your free trial",
    "subtitle": "{{days}} days free with every feature, no card needed.",
    "haveAccount": "Have an account?",
    "signIn": "Sign in",
    "terms": "I agree to the <terms>terms of use</terms> and the <privacy>privacy policy</privacy>.",
    "submit": "Get started free",
    "noCard": "No card needed. The trial lasts {{days}} days and you can cancel any time.",
    "side": {
      "kicker": "{{days}}-day free trial",
      "title": "A better hosting panel, with clearer prices.",
      "points": {
        "trial": "{{days}} days free with every feature, no card needed.",
        "install": "Install bPanel on Debian or Ubuntu with one command.",
        "ai": "Monthly AI credits with every server."
      },
      "preview": {
        "name": "Your first server",
        "accounts": "Hosting accounts",
        "from": "Plans start at",
        "perServer": "per server a month"
      }
    }
  },
  "checkEmail": {
    "title": "Check your email",
    "sentTo": "We sent a verification link to",
    "body": "Open it to verify your account and start the trial.",
    "bodyNoEmail": "We sent you a verification link. Open it to verify your account and start the trial.",
    "resend": "Resend the link",
    "resent": "We sent a new link.",
    "spam": "Not there? Check your spam folder.",
    "wrongEmail": "Wrong email? Sign up again"
  },
  "verify": {
    "title": "Verify email",
    "working": "Verifying your email",
    "successTitle": "Your email is verified",
    "successBody": "We're getting your dashboard ready.",
    "invalidTitle": "We couldn't verify your email",
    "invalidBody": "The link isn't valid or has expired.",
    "requestNew": "Ask for a new link",
    "toSignIn": "Sign in"
  },
  "signIn": {
    "title": "Sign in",
    "subtitle": "Welcome back to bPanel.",
    "forgot": "Forgot your password?",
    "submit": "Sign in",
    "noAccount": "No account yet?",
    "getStarted": "Get started free",
    "verifyNow": "Open the verification link",
    "mockHint": "Password for every demo account: {{password}}"
  },
  "totp": {
    "title": "Two-factor authentication",
    "body": "Enter the 6-digit code from your authenticator app.",
    "codeLabel": "Authentication code",
    "submit": "Verify",
    "back": "Back to sign in",
    "mockHint": "Code in demo mode: {{code}}"
  },
  "forgot": {
    "title": "Forgot your password?",
    "body": "Enter your email and we'll send you a link to set a new password.",
    "submit": "Send the link",
    "sentTitle": "Check your email",
    "sentBody": "If this email has an account, a link will arrive within minutes.",
    "back": "Back to sign in"
  },
  "reset": {
    "title": "New password",
    "body": "Choose a strong password you haven't used before.",
    "submit": "Save password",
    "doneTitle": "Your password is changed",
    "doneBody": "Sign in with your new password.",
    "toSignIn": "Sign in",
    "requestNew": "Ask for a new link"
  },
  "expired": {
    "title": "Your session ended",
    "body": "Sign in again and carry on from the same page.",
    "submit": "Continue",
    "signOut": "Sign out"
  },
  "mockInbox": {
    "title": "Demo inbox",
    "note": "Demo mode sends no real email. Open the message from here.",
    "empty": "No messages yet.",
    "openVerify": "Open the verification link",
    "openReset": "Open the password reset link",
    "latest": "Latest"
  },
  "demo": {
    "title": "Demo accounts",
    "note": "Sign in with one of these accounts to see the panel in different states.",
    "personas": {
      "rimal": "Four servers and invoice history",
      "najm": "Mid-trial, 5 days left",
      "new": "New account with no servers"
    }
  }
}
